module.exports = __webpack_public_path__ + "static/media/step-icon-right-2.6b86d320.svg";